<a class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard']">
  <sky-svg-icon icon="dashboard"></sky-svg-icon><span>Pulpit</span>
</a>
<a class="nav-link" routerLinkActive="active" [routerLink]="['/parking/active']">
  <sky-svg-icon icon="parking"></sky-svg-icon><span>Aktywne parkowania</span>
</a>
<a class="nav-link" routerLinkActive="active" [routerLink]="['/parking/history']">
  <sky-svg-icon icon="parking-history"></sky-svg-icon><span>Historia parkowań</span>
</a>
<a class="nav-link" routerLinkActive="active" [routerLink]="['/control/history']">
  <sky-svg-icon icon="control-history"></sky-svg-icon><span>Historia kontroli</span>
</a>
<ng-container *ngIf="canManageRoles$ | async">
  <a class="nav-link" routerLinkActive="active" [routerLink]="['/control/inspectors']">
    <sky-svg-icon icon="people"></sky-svg-icon><span>Lista kontrolerów</span>
  </a>
  <a class="nav-link" routerLinkActive="active" [routerLink]="['/administrators']">
    <sky-svg-icon icon="administrators"></sky-svg-icon><span>Administratorzy</span>
  </a>
</ng-container>
<a class="nav-link" routerLinkActive="active" [routerLink]="['/docs']">
  <sky-svg-icon icon="docs"></sky-svg-icon><span>Dokumenty</span>
</a>

<div class="navigation__footer">
  <a class="nav-link font-bold cursor-pointer" (click)="logout()"
    ><sky-svg-icon icon="logout"></sky-svg-icon><span>Wyloguj</span></a
  >
</div>
